// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Bisb from "../../../../core/Bisb.js";
import * as Buhta_cabinet__Button from "../../../html/Button.js";
import * as Buhta_cabinet__Form from "../../../../core/Form.js";
import * as Buhta_cabinet__Input from "../../../html/Input.js";
import * as Buhta_cabinet__Panel from "../../../html/Panel.js";
import * as Buhta_cabinet__Route from "../../../../Route.js";
import * as Buhta_components__LoadingDiv from "../../../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../../packages/core/lib/Toast.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../../packages/util/lib/DateTime.js";
import * as $$Promise from "../../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib from "melange/stdlib.js";
import HtmlReactParser from "html-react-parser";
import * as React from "react";
import * as ReactCopyToClipboard from "react-copy-to-clipboard";
import * as JsxRuntime from "react/jsx-runtime";

const actions = "hidden hover:flex absolute r-6 t-0 -translate-y-2/4 p-0.5 bg-gray-medium rounded";

const container = "flex px-6 py-2 relative hover:bg-gray-light";

const Styles = {
  actions: actions,
  container: container
};

function HelpChatPanel$Message(Props) {
  let text = Props.text;
  let avatarSrc = Props.avatarSrc;
  let name = Props.name;
  let sentAt = Props.sentAt;
  let readAt = Props.readAt;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("img", {
          className: "w-8 h-8",
          alt: "ava",
          src: avatarSrc
        }),
        className: "shrink-0 w-8 h-8"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                children: name
              }),
              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                className: "ml-2 text-gray-medium",
                children: sentAt
              })
            ],
            className: "flex"
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: "help-chat-panel",
              children: HtmlReactParser(text)
            }),
            className: "mt-1"
          }),
          readAt !== undefined ? JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("img", {
                  src: StaticAsset.src("/static/icons/visible.svg")
                }),
                JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                  className: "ml-1 text-default-gray",
                  children: JsxRuntime.jsx(Buhta_components__Text.Span.make, {
                    fontWeight: "initial",
                    children: "Просмотрено в " + readAt
                  })
                })
              ],
              className: "flex items-center mt-1.5"
            }) : null
        ],
        className: "ml-3"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("button", {
            children: JsxRuntime.jsx("img", {
              src: StaticAsset.src("/static/icons/note.svg")
            }),
            className: "hover:bg-white-12 hover:rounded-xs"
          }),
          JsxRuntime.jsx("button", {
            children: JsxRuntime.jsx("img", {
              src: StaticAsset.src("/static/icons/more-white.svg")
            }),
            className: "hover:bg-white-12 hover:rounded-xs ml-0.5"
          })
        ],
        className: actions
      })
    ],
    className: Cn.fromList({
      hd: container,
      tl: {
        hd: "animate-inBottom",
        tl: /* [] */ 0
      }
    })
  });
}

const Message = {
  Styles: Styles,
  make: HelpChatPanel$Message
};

const actions__row = "flex px-6 py-3 items-center";

const Styles$1 = {
  actions__row: actions__row
};

function HelpChatPanel$MessageWriter(Props) {
  let onSubmit = Props.onSubmit;
  let orgId = Props.orgId;
  let id = Props.id;
  const match = React.useState(function () {
    return "";
  });
  const setText = match[1];
  const text = match[0];
  const match$1 = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match$1[0];
  const match$2 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match$2[1];
  const submit = function (text) {
    const __x = Curry._4(Buhta_cabinet__Bisb.CrmService.TicketService.sendMessage, tenant.ctx, orgId, id, text);
    return $$Promise.flatMap(__x, (function (result) {
      if (result.TAG === /* Ok */ 0) {
        Curry._1(setText, (function (param) {
          return "";
        }));
        Curry._1(onSubmit, result._0);
      } else {
        Curry._1(dispatchToasts, {
          TAG: /* Add */ 0,
          _0: {
            id: Buhta_core__Toast.generateId(undefined),
            text: result._0.message,
            kind: "warning",
            onClick: (function (param) {
              
            })
          }
        });
      }
      return $$Promise.resolved(result);
    }));
  };
  const form = Buhta_cabinet__Form.useForm(submit);
  return JsxRuntime.jsxs("form", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Buhta_cabinet__Input.make, {
          value: text,
          placeholder: "Текст сообщения..",
          onChange: (function (value) {
            Curry._1(setText, (function (param) {
              return value;
            }));
          })
        }),
        className: "input_container"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("button", {
            children: JsxRuntime.jsx("img", {
              src: StaticAsset.src("/static/icons/category.svg")
            })
          }),
          JsxRuntime.jsx("button", {
            children: JsxRuntime.jsx("img", {
              src: StaticAsset.src("/static/icons/attache.svg")
            }),
            className: "ml-4"
          }),
          JsxRuntime.jsx("button", {
            children: JsxRuntime.jsx("img", {
              className: "w-6 h-6",
              src: StaticAsset.src("/static/icons/user.svg")
            }),
            className: "ml-4"
          }),
          JsxRuntime.jsx("button", {
            children: JsxRuntime.jsx("img", {
              src: StaticAsset.src("/static/icons/link.svg")
            }),
            className: "ml-4"
          }),
          JsxRuntime.jsx("button", {
            children: JsxRuntime.jsx("img", {
              src: StaticAsset.src("/static/icons/image.svg")
            }),
            className: "ml-4"
          }),
          JsxRuntime.jsx(Buhta_cabinet__Button.make, {
            size: "s",
            state: form.isSubmitting ? "Loading" : "Default",
            type_: "submit",
            className: "ml-auto",
            disabled: form.isSubmitting,
            children: "Отправить"
          })
        ],
        className: actions__row
      })
    ],
    className: "flex flex-col",
    onSubmit: (function (ev) {
      Curry._1(form.submit, text);
      ev.preventDefault();
    })
  });
}

const MessageWriter = {
  Styles: Styles$1,
  make: HelpChatPanel$MessageWriter
};

const _map = {"received":"received","closed":"closed","unread":"unread","markAdded":"markAdded"};

function tToJs(param) {
  return param;
}

function tFromJs(param) {
  return _map[param];
}

function containerStyle(status) {
  const statusPy = Caml_obj.caml_equal(status, "received") ? "py-2" : "py-1";
  return "px-3 " + statusPy + " rounded-md mx-auto my-2 animate-inBottom";
}

const Styles$2 = {
  containerStyle: containerStyle
};

function HelpChatPanel$MessageStatus(Props) {
  let status = Props.status;
  let name = Props.name;
  let time = Props.time;
  return JsxRuntime.jsx("div", {
    children: status === "unread" ? JsxRuntime.jsx(Buhta_components__Text.LabelSmall.make, {
        className: "text-secondary",
        children: "Непрочитанные сообщения"
      }) : (
        status === "markAdded" ? JsxRuntime.jsx(Buhta_components__Text.LabelSmall.make, {
            className: "text-gray-medium",
            children: "добавлена заметка ･ " + name + ", " + time
          }) : (
            status === "closed" ? JsxRuntime.jsx(Buhta_components__Text.LabelSmall.make, {
                className: "text-gray-medium",
                children: "Запрос закрыт ･ " + name + ", " + time
              }) : JsxRuntime.jsx(Buhta_components__Text.LabelSmall.make, {
                className: "text-success",
                children: "Запрос принят"
              })
          )
      ),
    className: Cn.fromList({
      hd: containerStyle(status),
      tl: {
        hd: status === "unread" ? "bg-[rgba(15,184,237,0.08)]" : (
            status === "closed" || status === "markAdded" ? "bg-gray-light" : "bg-[rgba(77,172,44,0.08)]"
          ),
        tl: /* [] */ 0
      }
    })
  });
}

const MessageStatus = {
  tToJs: tToJs,
  tFromJs: tFromJs,
  Styles: Styles$2,
  make: HelpChatPanel$MessageStatus
};

function HelpChatPanel$Chat(Props) {
  let ticket = Props.ticket;
  let onClose = Props.onClose;
  const match = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match[1];
  const messagesEndRef = React.useRef(null);
  const match$1 = React.useState(function () {
    return ticket.actions;
  });
  const setActions = match$1[1];
  const actions = match$1[0];
  const id = ticket.id;
  React.useEffect((function () {
    const __x = messagesEndRef.current;
    Belt__Belt_Option.map((__x == null) ? undefined : Caml_option.some(__x), (function (el) {
      return el.scrollIntoView({
        behavior: "smooth"
      });
    }));
  }), [actions]);
  return JsxRuntime.jsxs(Buhta_cabinet__Panel.make, {
    title: "Запрос #" + String(id),
    titleAlign: "left",
    textSize: "m",
    leftActions: {
      hd: JsxRuntime.jsx("button", {
        children: JsxRuntime.jsx("img", {
          src: StaticAsset.src("/static/icons/close.svg")
        }),
        onClick: (function (param) {
          Curry._1(onClose, undefined);
        })
      }),
      tl: /* [] */ 0
    },
    rightActions: {
      hd: JsxRuntime.jsx(ReactCopyToClipboard.CopyToClipboard, {
        text: Buhta_cabinet__Route.toAbsoluteString({
          TAG: /* Admin */ 7,
          _0: {
            TAG: /* Help */ 3,
            _0: {
              TAG: /* Tickets */ 0,
              _0: {
                TAG: /* View */ 0,
                _0: id
              }
            }
          }
        }),
        onCopy: (function (param) {
          Curry._1(dispatchToasts, {
            TAG: /* Add */ 0,
            _0: {
              id: Buhta_core__Toast.generateId(undefined),
              text: "Скопировано в буфер обмена",
              kind: "success",
              onClick: (function (param) {
                
              })
            }
          });
        }),
        children: JsxRuntime.jsx("button", {
          children: JsxRuntime.jsx("img", {
            alt: "link",
            src: StaticAsset.src("/static/icons/link.svg")
          }),
          onClick: (function (param) {
            
          })
        })
      }),
      tl: {
        hd: JsxRuntime.jsx("button", {
          children: JsxRuntime.jsx("img", {
            src: StaticAsset.src("/static/icons/more.svg")
          })
        }),
        tl: /* [] */ 0
      }
    },
    className: "h-full",
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          Belt__Belt_List.toArray(Belt__Belt_List.map(actions, (function (action) {
            const match = action.type_;
            if (match === "closed") {
              return JsxRuntime.jsx(HelpChatPanel$MessageStatus, {
                status: "closed",
                name: action.author.display_name,
                time: DateTime.toLocalFormat(action.created_at)
              });
            }
            const Key = String(action.id);
            return JsxRuntime.jsx(HelpChatPanel$Message, {
              text: action.body,
              avatarSrc: StaticAsset.src("/static/icons/profile-photo.png"),
              name: action.author.display_name,
              sentAt: DateTime.toLocalFormat(action.created_at)
            }, Key);
          }))),
          JsxRuntime.jsx("div", {
            ref: messagesEndRef
          })
        ],
        className: "px-0 py-6 grow flex flex-col overflow-auto"
      }),
      JsxRuntime.jsx(HelpChatPanel$MessageWriter, {
        onSubmit: (function (action) {
          Curry._1(setActions, (function (param) {
            return Stdlib.$at(actions, {
              hd: action,
              tl: /* [] */ 0
            });
          }));
        }),
        orgId: ticket.org.id,
        id: id
      })
    ]
  });
}

const Chat = {
  make: HelpChatPanel$Chat
};

function HelpChatPanel(Props) {
  let ticket = Props.ticket;
  let onClose = Props.onClose;
  let className = Props.className;
  return JsxRuntime.jsx("div", {
    children: typeof ticket === "string" ? JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {}) : (
        ticket.NAME === "Data" ? JsxRuntime.jsx(HelpChatPanel$Chat, {
            ticket: ticket.VAL,
            onClose: onClose
          }) : "Error: " + ticket.VAL.message
      ),
    className: Cn.fromList({
      hd: Cn.take(className),
      tl: /* [] */ 0
    })
  });
}

const make = HelpChatPanel;

export {
  Message,
  MessageWriter,
  MessageStatus,
  Chat,
  make,
}
/* Buhta_cabinet__Bisb Not a pure module */
